import { getApolloClient, newInMemoryCache } from '@vend/apollo-utilities'
import { productHistoryProductSessionsPagination } from '@vend/business-components'

export const client = getApolloClient({
  cache: newInMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // Pagination of product history session within the Product Binder / Product Modal.
          productHistoryProductSessions: productHistoryProductSessionsPagination,
        },
      },
      Contact: {
        merge: true,
      },
      Money: {
        merge: true,
      },
      Retailer: {
        merge: true,
      },
    },
  }),
})
